
export default function Contact() {
  return (
    <footer id="contact" className="relative py-20 bg-gray-100">
      <div className="absolute top-0 left-0 w-64 h-64 bg-gray-800 transform -rotate-12 -translate-x-20 -translate-y-20 rounded-3xl"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-gray-800 transform rotate-12 translate-x-20 translate-y-20 rounded-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-8">
        <div className="bg-white rounded-3xl shadow-lg p-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/ebcdf7a9-2e92-462c-8afb-73f0da2ccf5f.png" 
                  alt="JAMNIK d.o.o. Logo" 
                  className="h-8 w-auto object-contain"
                />
                <h3 className="text-xl font-bold text-gray-900">JAMNIK d.o.o.</h3>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed max-w-xs">
                A team of experts developing modern applications for the iOS platform
              </p>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-wider text-gray-900 font-semibold mb-6">
                Products
              </h4>
              <ul className="space-y-4 text-sm text-gray-700">
                <li className="cursor-pointer hover:text-gray-900 transition-colors whitespace-nowrap">VPN Protection</li>
                <li className="cursor-pointer hover:text-gray-900 transition-colors whitespace-nowrap">System Cleaner</li>
                <li className="cursor-pointer hover:text-gray-900 transition-colors whitespace-nowrap">iOS Solutions</li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-wider text-gray-900 font-semibold mb-6">
                Company
              </h4>
              <ul className="space-y-4 text-sm text-gray-700">
                <li className="cursor-pointer hover:text-gray-900 transition-colors whitespace-nowrap">About Us</li>
                <li className="cursor-pointer hover:text-gray-900 transition-colors whitespace-nowrap">Technology</li>
                <li className="cursor-pointer hover:text-gray-900 transition-colors whitespace-nowrap">Privacy Policy</li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-wider text-gray-900 font-semibold mb-6">
                Contact
              </h4>
              <ul className="space-y-5 text-sm text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-base text-blue-600 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                  <span>Barletova cesta 4S<br />Medvode</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-map-2-line text-base text-blue-600 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                  <span>1215, Slovenia</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-mail-line text-base text-blue-600 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                  <span>info@jamnikdoo.com</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-phone-line text-base text-blue-600 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                  <span>+1 3203498345</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200 flex justify-between items-center">
            <p className="text-xs text-gray-500">
              © 2025 JAMNIK d.o.o. All rights reserved
            </p>
            <div className="flex items-center gap-6">
              <i className="ri-linkedin-box-fill text-xl text-gray-600 hover:text-blue-600 transition-colors cursor-pointer w-5 h-5 flex items-center justify-center"></i>
              <i className="ri-twitter-x-fill text-xl text-gray-600 hover:text-blue-600 transition-colors cursor-pointer w-5 h-5 flex items-center justify-center"></i>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}